import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
const flow = ['What you already know', 'What you still need to investigate', 'What matters most', 'What you should do next', 'What functional change you want to measure'];
export function FinalCTA() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-138" data-mp="3rqs9iwfaw3zb">
      <div className="mx-auto max-w-2xl text-center" data-id="element-139" data-mp="3dv6largw5o7y">
        <h2 id="final-title" className="font-serif text-[30px] font-bold leading-[1.15] text-white sm:text-5xl" data-id="element-140" data-mp="3huxh59l9yujc">
          Ready to stop asking <em className="text-gold" data-id="element-141" data-mp="33wqtsndyccxx">“What do I do next?”</em>
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-brand-light" data-id="element-142" data-mp="38v222tolmfe1">
          You don’t need another giant pile of theory. You need a clearer way to move from:
        </p>

        <ol className="mx-auto mt-8 max-w-sm" data-id="element-143" data-mp="1735s3oi2xdld">
          {flow.map((step, i) => <li key={step} className="flex flex-col items-center" data-id="element-144" data-mp="q8dgoxbliws8" data-mpi={i}>
              <span className="w-full rounded-xl bg-white/10 px-4 py-3 text-[15px] font-bold uppercase tracking-wide text-white" data-id="element-145" data-mp="q6iulfol8ymk">{step}</span>
              {i < flow.length - 1 && <ArrowDownIcon className="my-1.5 h-5 w-5 text-brand-light" aria-hidden="true" data-id="element-146" data-mp="yzvz7ew0looh" />}
            </li>)}
        </ol>

        <p className="mt-8 text-[16px] text-brand-light" data-id="element-147" data-mp="v1gclc3uiibl">That’s exactly what I created the Sensory Clinical Route™ to help you organize.</p>
        <p className="mt-6 font-serif text-5xl font-extrabold text-white" data-id="element-148" data-mp="2b7pr6yd79qo">
          Only <span className="text-gold" data-id="element-149" data-mp="gafra6i02ty1">USD $27</span>
        </p>

        <div className="mt-8" data-id="element-150" data-mp="gbqxecyx4dsb">
          <CTAButton label="Get the Sensory Clinical Route™" showSubtext dark data-id="element-151" data-mp="bbcoksphszt8" />
        </div>
        <Countdown dark data-id="element-152" data-mp="1rpmcjlptomjj" />
      </div>
    </section>;
}